
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';

import logo from '../Images/logo.png';
// import { Link } from 'react-router-dom';
import { Container } from 'react-bootstrap';



function BasicExample() {
    return (
        <>
        <Navbar expand="lg" className="bg-body-tertiary w-100">
            <Container>
        
                <Navbar.Brand ><img
                    src={logo}
                    alt="Logo"
                    width="150"
                    className="img-fluid"
                /></Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="me-auto">
                        <Nav.Link href="/">Home</Nav.Link>
                        <Nav.Link href="/about">About Us</Nav.Link>
                        <Nav.Link href="/infrastructure">Infrastructure</Nav.Link>
                        <Nav.Link href="/services">Services</Nav.Link>
                        <Nav.Link href="/quality">Quality</Nav.Link>
                        <Nav.Link href="/contact">Contact Us</Nav.Link>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
        
     
        </>
    );
}

export default BasicExample;